import { useEffect } from 'react';
import Lenis from 'lenis';
import 'lenis/dist/lenis.css';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default function SmoothScroll() {
  useEffect(() => {
    // Skip Lenis on mobile — native scroll works better on touch devices
    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    if (isMobile) return;

    // Initialize Lenis with respectReducedMotion: false so OS/browser settings never disable smooth scroll
    const lenis = new Lenis({
      autoRaf: true,
      anchors: true,
      respectReducedMotion: false,
      smoothWheel: true,
      syncTouch: true,
      lerp: 0.05,
      duration: 1.4,
      wheelMultiplier: 1.1,
      touchMultiplier: 1.5,
    });

    window.lenis = lenis;

    // Synchronize Lenis scroll updates with GSAP ScrollTrigger
    const unbindScroll = lenis.on('scroll', () => {
      ScrollTrigger.update();
    });

    gsap.ticker.lagSmoothing(0);

    return () => {
      unbindScroll();
      lenis.destroy();
    };
  }, []);

  return null;
}
